<div
  rvSpinner="screen-share-loader"
  [rvShowSpinner]="!availableDisplays || loadingDisplays()"
  [class.tw-pb-[88px]]="selectedCount > 0"
  class="tw-px-4 tw-max-w-[1024px] tw-m-auto"
>
  <div class="tw-bg-gray-100">
    <moderator-join-instructions-card />

    @if (currentlyExistingSession?.sessionId) {
      <div
        class="tw-flex tw-items-center tw-gap-[16px] tw-justify-between tw-bg-white tw-m-auto tw-rounded-2xl tw-py-6 tw-px-6 md:!tw-px-8 tw-mx-4 md:!tw-mx-auto tw-mt-6 tw-border-solid tw-border-gray-200"
      >
        <span>
          <b>Session in progress.</b> Would you like to rejoin your current
          session?
        </span>
        <div class="tw-flex tw-items-center tw-flex-row tw-gap-[8px]">
          <button
            mat-flat-button
            class="small tw-leading-[14px]"
            color="primary"
            (click)="joinExistingSession(currentlyExistingSession)"
          >
            Rejoin Session
          </button>

          <button
            matButton="outlined"
            class="small tw-leading-[14px] button-role--danger"
            (click)="endSession(currentlyExistingSession!.sessionId)"
          >
            End Session
          </button>
        </div>
      </div>
    }

    @if (availableDisplays) {
      @if (!canModerateScreenShare) {
        <div class="moderator-notice aligner flex-col">
          @if (userStateService.isUserAdmin()) {
            <img
              src="/images/screen-sharing/permissions.png"
              width="200"
              height="200"
              alt="User Permissions"
            />
            <h4>Permission Needed</h4>
            <p class="align-center">
              Good news! You are an admin, and can give yourself permission to
              use Screen Share Moderation. Please go to User Settings and check
              the role "Screen Share Moderator".
            </p>
            @if (!rvshareAppDetectionService.isScreenShareApp()) {
              <a
                mat-flat-button
                color="primary"
                class="my-4 px-4"
                uiSref="apps.user.details"
                >See My User Settings</a
              >
            }
          } @else {
            <img
              src="/images/screen-sharing/padlock.png"
              width="200"
              height="200"
              alt="Permission Needed"
            />
            <h4>Permission Needed</h4>
            <p class="">
              You don't have permission to use Screen Share Moderated Session.
              Please ask the admin to assign you the role of "Screen Share
              Moderator."
            </p>
          }
        </div>
      } @else {
        <div class="moderator-join-layout tw-pb-4">
          <div>
            @if (screenSharingService.channelError) {
              <div class="madero-style alert alert-danger mt-3">
                <div class="flex flex-row align-start">
                  <mat-icon
                    aria-hidden="true"
                    fontIcon="fa-times-circle"
                    class="icon-left"
                  ></mat-icon>
                  <p class="mb-0">
                    {{ screenSharingService.channelError }}
                  </p>
                </div>
              </div>
            }
          </div>
          <div class="tw-flex tw-items-center tw-justify-between tw-gap-4">
            <h3 class="tw-text-3xl tw-font-semibold tw-text-gray-900 tw-mb-4">
              Choose a Display to start sharing
            </h3>
            <button
              class="btn btn-sm !tw-w-[40px] !tw-h-[40px] tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-bg-white tw-border-gray-300 tw-shadow-sm"
              (click)="load()"
              matTooltip="Refresh"
              matTooltipClass="menu-tooltip"
              matTooltipPosition="left"
            >
              <mat-icon
                aria-hidden="true"
                svgIcon="refresh"
                class="tw-text-[16px] tw-w-4 tw-h-4"
              ></mat-icon>
            </button>
          </div>

          <div
            class="tw-flex tw-flex-col md:!tw-flex-row md:!tw-items-center tw-gap-3 tw-mb-4"
          >
            <div class="tw-flex-1">
              <search-filter
                [filterConfig]="filterConfig"
                [search]="search"
                [doSearch]="
                  activeTabIndex === 0 ? loadDisplays : searchFavorites
                "
                [localSearch]="activeTabIndex === 1"
                [focus]="true"
              />
            </div>
            <div
              class="tw-flex tw-flex-row tw-gap-2 tw-justify-end tw-shrink-0 tw-mt-[12px] md:!tw-mt-0"
            >
              <button
                class="tab-button"
                [class.tab-button--active]="activeTabIndex === 0"
                (click)="onTabClicked(0)"
              >
                All Displays
              </button>
              <button
                class="tab-button"
                [class.tab-button--active]="activeTabIndex === 1"
                (click)="onTabClicked(1)"
              >
                <mat-icon
                  svgIcon="star"
                  [class.tw-text-white]="activeTabIndex === 1"
                  class="!tw-w-[18px] !tw-h-[18px] !tw-min-w-[18px] !tw-min-h-[18px] [&_svg_path]:tw-stroke-[1.5px]"
                ></mat-icon>
                Favorites
              </button>
            </div>
          </div>

          <div
            class="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border-solid tw-border-gray-200 tw-overflow-x-auto"
          >
            <div class="tw-min-w-[780px]">
              @if (foldersSupported && activeTabIndex === 0) {
                <folder-path
                  class="tw-block tw-px-[16px] tw-w-full"
                  [folderTree]="folderService.folderPathTree"
                  [folderId]="currentFolderId"
                  (folderClicked)="onFolderClicked($event)"
                  rootName="Displays"
                ></folder-path>
                <rv-divider></rv-divider>
              }
              <table
                mat-table
                [dataSource]="displayTableDataSource"
                class="tw-bg-white tw-rounded-2xl tw-table-fixed tw-mb-4 tw-w-full"
              >
                <ng-container matColumnDef="name">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="tw-px-[16px] tw-min-w-[300px]"
                  >
                    <div class="tw-flex tw-flex-row tw-items-center">
                      <mat-checkbox
                        (click)="$event.stopPropagation(); toggleSelectAll()"
                        [checked]="isAllSelected()"
                        [indeterminate]="selectedCount > 0 && !isAllSelected()"
                        class="tw-mr-4"
                      ></mat-checkbox>
                      <span>Display Name</span>
                    </div>
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let display"
                    class="tw-px-[16px] tw-py-0 tw-min-w-[300px]"
                  >
                    <div
                      class="tw-flex tw-flex-row tw-items-center tw-gap-[16px] tw-min-w-0"
                    >
                      @if (display.isFolder) {
                        <div class="tw-w-[30px] tw-shrink-0"></div>
                        <mat-icon
                          svgIcon="folder"
                          class="tw-text-gray-500 tw-shrink-0"
                        ></mat-icon>
                        <span class="tw-font-medium tw-truncate">{{
                          display.name
                        }}</span>
                      } @else {
                        <mat-checkbox
                          (click)="
                            $event.stopPropagation();
                            toggleSelection(display.id)
                          "
                          [checked]="isSelected(display.id)"
                          [disabled]="isDisabled(display.id)"
                          [class.tw-opacity-50]="
                            !display.isFolder && isDisabled(display.id)
                          "
                        ></mat-checkbox>
                        @if (display.savingFavorite) {
                          <mat-spinner diameter="20"></mat-spinner>
                        } @else {
                          <button
                            mat-icon-button
                            type="button"
                            class="tw-shrink-0 tw-w-[20px] tw-h-[20px]"
                            focus-outline
                            (click)="
                              $event.stopPropagation();
                              toggleFavorite(display.id)
                            "
                            [matTooltip]="
                              isFavored(getDisplay(display.id))
                                ? 'Remove from Favorites'
                                : 'Add to Favorites'
                            "
                            matTooltipClass="menu-tooltip"
                            [attr.aria-label]="
                              isFavored(getDisplay(display.id))
                                ? 'Remove from Favorites'
                                : 'Add to Favorites'
                            "
                          >
                            <mat-icon
                              class="tw-text-[`#8D94A1`]"
                              [svgIcon]="
                                isFavored(getDisplay(display.id))
                                  ? 'star-gold'
                                  : 'star'
                              "
                            ></mat-icon>
                          </button>
                        }
                        <span class="tw-font-medium tw-truncate">{{
                          display.name
                        }}</span>
                      }
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="existingSession">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="tw-px-[16px]"
                    width="300"
                  >
                    Existing Session
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let display"
                    class="tw-px-[16px] tw-py-0"
                  >
                    @if (
                      companyModSessionsPerDisplayId[display.id]?.sessionId
                    ) {
                      <div
                        class="tw-flex tw-items-center tw-flex-row tw-gap-[8px]"
                      >
                        <button
                          mat-flat-button
                          class="small"
                          color="primary"
                          (click)="
                            joinExistingSession(
                              companyModSessionsPerDisplayId[display.id]
                            )
                          "
                        >
                          Join Session
                        </button>

                        <button
                          matButton="outlined"
                          class="small button-role--danger"
                          (click)="
                            endSession(
                              companyModSessionsPerDisplayId[display.id]
                                .sessionId!
                            )
                          "
                        >
                          End Session
                        </button>
                      </div>
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="tw-px-[16px]"
                    width="180"
                  >
                    Status
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let display"
                    class="tw-px-[16px] tw-py-0"
                  >
                    @if (!display.isFolder) {
                      <div
                        class="tw-flex tw-flex-row tw-gap-8 tw-font-semibold"
                      >
                        <rv-badge
                          [color]="
                            display.onlineStatus === 'online' ? 'green' : 'gray'
                          "
                          [text]="
                            display.onlineStatus.replace('_', ' ') | titlecase
                          "
                        />
                      </div>
                    }
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                <tr
                  mat-row
                  class="hover:tw-bg-gray-100"
                  [attr.tabindex]="
                    row.isFolder || (!row.isFolder && !isDisabled(row.id))
                      ? 0
                      : -1
                  "
                  [ngClass]="{
                    'moderator-join-row--selected':
                      !row.isFolder && isSelected(row.id),
                    u_clickable:
                      row.isFolder || (!row.isFolder && !isDisabled(row.id)),
                    'tw-cursor-not-allowed':
                      !row.isFolder && isDisabled(row.id),
                  }"
                  *matRowDef="let row; columns: tableColumns"
                  (click)="onRowClicked(row)"
                  (keydown.enter)="onRowClicked(row)"
                  (keydown.space)="$event.preventDefault(); onRowClicked(row)"
                ></tr>
              </table>
              @if (activeTabIndex === 0 && availableDisplays.length === 0) {
                <div class="aligner flex-col tw-py-[32px]">
                  <img
                    src="/images/screen-sharing/settings.png"
                    width="200"
                    height="200"
                    alt="Display Settings"
                  />
                  <h4 class="tw-text-[22px] tw-font-semibold tw-my-[16px]">
                    No Displays with Screen Share Enabled
                  </h4>
                  <div class="tw-max-w-[500px] tw-mx-auto">
                    <p class="tw-text-[14px] tw-mb-6">
                      To enable Screen Share:
                    </p>
                    <ol
                      class="tw-text-left tw-inline-block tw-text-[14px] tw-leading-relaxed tw-pl-[18px]"
                    >
                      <li class="tw-mb-2">
                        Go to <strong>Displays</strong> and select a display.
                      </li>
                      <li class="tw-mb-2">
                        In the General tab, toggle
                        <strong>License this display.</strong>
                      </li>
                      <li class="tw-mb-2">
                        In the Screen Sharing tab, toggle
                        <strong>Enable Screen Share.</strong>
                      </li>
                    </ol>
                  </div>
                  @if (!rvshareAppDetectionService.isScreenShareApp()) {
                    <a
                      mat-flat-button
                      color="primary"
                      class="tw-mt-6 tw-px-8"
                      uiSref="apps.displays.list"
                      >See Displays</a
                    >
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    }
  </div>

  <moderator-join-bulk-actions-bar
    [selectedCount]="selectedCount"
    (startSharing)="startSharingWithSelected()"
    (clearSelection)="clearSelection()"
  />
</div>
